<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <div id="my-table-id">
        <v-data-table :headers="headers" :items="salary_rule_master_list" dense class="elevation-1 mytable"
          :search="search">
          <template v-slot:top>
            <v-toolbar dense class="toolbar" flat color="white">
              <v-toolbar-title>Salary Rule Master</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>

            <span style="width: 20px"> </span>
            <v-row dense>
              <v-col cols="12" sm="3" md="3">
                <!-- <v-btn
                color="success"
                outlined
                rounded
                v-if="salary_rule_master_list.length != 0"
              >
                <download-excel
                  class="mr-2 pb-3 pt-2"
                  :data="salary_rule_master_list"
                  :fields="table_fields"
                  worksheet="PayRoll_SalaryRuleMaster"
                  name="PayRoll_SalaryRuleMaster.xls"
                >
                  <v-icon dark>mdi-file-excel</v-icon> Export
                </download-excel>
              </v-btn> -->
                <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'SalaryRuleMaster')"
                  :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
              </v-col>
              <v-col sm="6" md="4" cols="12">
                <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                </v-text-field>
              </v-col>
              <span style="width: 20px"></span>
              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn class="mb-2 button" v-on="on" small>Add Salary Rule Master</v-btn>
                </template>
                <v-card>
                  <v-form v-model="valid">
                    <v-card-title class="toolbar">
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-autocomplete dense v-model="editedItem.salary_rule_super_master_list"
                              :items="salary_rule_super_master_list" label="Select Salary Rule" persistent-hint
                              :disabled="editedIndex != -1"></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field v-model="editedItem.displayname" label="Display Name"
                              hint="PF_RULE_PER_OF_BASIC_PLUS_DP_PLUS_DA..."
                              :rules="[(v) => !!v || 'required']"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <v-textarea solo v-model="editedItem.description" persistent-hint
                              hint="For example :: PF_RULE_PER_OF_BASIC_PLUS_DP_PLUS_DA" label="Description"
                              :rules="[(v) => !!v || 'required']">
                            </v-textarea>
                          </v-col>
                          <v-col cols="12" v-if="editedIndex != -1">
                            <v-checkbox v-model="editedItem.status" color="success" label="Active"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                      <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <template v-slot:item.status="{ item }">
            <v-switch v-model="item.status" inset color="success" @change="toggleGroup(item)"></v-switch>
          </template>
          <template v-slot:item.action="{ item }">
            <div>
              <v-avatar style="" size="25" class="edit-avatar">
                <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    valid: false,
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "Salary Rule", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Sr No.",
        align: "left",
        value: "srno",
      },
      {
        text: "Name",
        align: "left",
        value: "name",
      },
      {
        text: "Display Name",
        align: "left",
        value: "displayname",
      },
      {
        text: "Description",
        align: "left",
        value: "description",
      },
      {
        text: "Status",
        align: "left",
        sortable: false,
        value: "status",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      "Sr no.": "srno",
      Name: "name",
      "Display Name": "displayname",
      Description: "description",
      Status: "status",
    },
    salary_rule_master_list: [],
    salary_rule_super_master_list: [],
    editedIndex: -1,
    editedItem: {
      salary_rule_super_master_list: "",
      id: 0,
      name: "",
      status: true,
      displayname: "",
      description: "",
    },
    defaultItem: {
      salary_rule_super_master_list: "",
      id: 0,
      name: "",
      status: true,
      displayname: "",
      description: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Salary Rule Master"
        : "Edit Salary Rule Master";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Name</th>
      <th>Display Name</th>
      <th>Description</th>
      <th>Status</th>
      
    </tr>`;

  this.salary_rule_master_list.forEach((item, index) => {
    tab_text += `
    <tr>
      <td>${index + 1}</td>
      <td>${item.name}</td>
      <td>${item.displayname}</td>
      <td>${item.description}</td>
      <td>${item.status ? 'Active' : 'Inactive'}</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    toggleGroup(item) {
      const formData = {
        id: item.id,
        status: item.status,
      };
      axios
        .post("/Payroll/toggleSalaryRuleMaster", formData)
        .then((res) => {
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar(
              "#4caf50",
              "Salary Rule Master Status Changed..."
            );
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        });
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/salaryRuleMaster")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.salary_rule_master_list = res.data.srm_list;
            this.salary_rule_super_master_list = res.data.srm_super_master_list;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.salary_rule_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        // if (this.isValidated()) {
        console.log("2");
        axios
          .post("/Payroll/editSalaryRuleMaster", this.editedItem)
          .then((res) => {
            if (res.data.status == "YES") {
              Object.assign(
                this.salary_rule_master_list[this.editedIndex],
                this.editedItem
              );
              this.onLoad();
              this.showSnackbar(
                "#4caf50",
                "Salary Rule Master Updated Successfully..."
              ); // show snackbar on success
            } else if (res.data.status == "NO") {
              this.showSnackbar(
                "#b71c1c",
                "Salary Rule Master Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
        // }
      } else {
        console.log("save api data");
        console.log(this.editedItem);
        axios
          .post("/Payroll/saveSalaryRuleMaster", this.editedItem)
          .then((res) => {
            if (res.data.status == "YES") {
              // this.salary_component_list.push(this.editedItem);
              this.onLoad();
              this.showSnackbar(
                "#4caf50",
                "Salary Rule Master Added Successfully..."
              ); // show snackbar on success
            } else if (res.data.status == "NO") {
              this.showSnackbar(
                "#b71c1c",
                "Salary Rule Master Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    // isValidated() {
    //   if (this.editedItem.salary_rule_super_master_list) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>